// NOTE: deliberately react-native's SafeAreaView, NOT react-native-safe-area-context.
// This wraps the Stack's `header` renderer, so its height is what useHeaderHeight()
// returns, which feeds useVerticalOffsetHeight() -> KeyboardAvoidingView on login.tsx.
// safe-area-context is NOT a drop-in here: edges={['top']} makes the header taller and
// the absolutely-positioned Login button rides up over the password field when the
// keyboard opens; edges={[]} fixes that but clips the header under the notch. Migrating
// off the deprecated component needs the login layout reworked, not just a swap.
import * as storage from '../../utils/storage';
import React, { useEffect } from 'react';
import { PublicPagesHeader } from '../../components/Header/PublicPages';
import { SafeAreaView } from 'react-native';
import {Stack, router, useGlobalSearchParams, useSegments} from 'expo-router';
import { anonymousRegisterStringForStore, elliRedirectStringForStore, elliRedirectUrlParam, elliTokenStringForStore, elliTokenUrlParam, redirectStringForStore, registrationCodeStringForStore } from '../../constants/storageKeys';
import { concatPath } from '../../utils/links/concatPath';
import { contactKey, needUpdateKey, publicKey, tabsKey } from '../../constants/routeKeys';










export default function Layout(){
  const params = useGlobalSearchParams();
  const segment = useSegments();

  useEffect(() => {
    if(params && redirectStringForStore in params) {
      storage.saveString(redirectStringForStore, params[redirectStringForStore] as string);
    }
    if(params && anonymousRegisterStringForStore in params) {
      storage.saveString(anonymousRegisterStringForStore,params[anonymousRegisterStringForStore] as string);
    }
    if(params && registrationCodeStringForStore in params) {
      storage.saveString(registrationCodeStringForStore,params[registrationCodeStringForStore] as string);
    }
    // Handle Elli token from URL param ?elli-token=<token>
    if(params && elliTokenUrlParam in params) {
      storage.saveString(elliTokenStringForStore, params[elliTokenUrlParam] as string);
    }
    // Handle Elli redirect URL from URL param ?elli-redirect=<url>
    if(params && elliRedirectUrlParam in params) {
      const redirectUrl = params[elliRedirectUrlParam] as string;
      // Validate redirect URL domain
      const allowedDomains = ['app.elli.be', 'app-acc.elli.be', 'app-dev.elli.be'];
      try {
        const url = new URL(redirectUrl);
        if (allowedDomains.includes(url.hostname)) {
          storage.saveString(elliRedirectStringForStore, redirectUrl);
        }
      } catch {
        // Invalid URL, ignore
      }
    }
  }, [params]);

  const goToContact = () => {
    router.navigate(concatPath([ publicKey, contactKey], -1) as string);
  };


  return (
    <Stack  initialRouteName={tabsKey} screenOptions={{
      gestureEnabled: false,
      contentStyle: { backgroundColor: '#fff' },
      header: () => {
        return (
          <SafeAreaView style={{ paddingHorizontal: 40, backgroundColor: '#fff' }}>
            <PublicPagesHeader onPress={() => {
              goToContact();
            }} withContactToSupport={!segment.includes(needUpdateKey)}
            />
          </SafeAreaView>
        );
      },
    }}/>
  );
}
